import humanFormat from 'human-format'
import numeral from 'numeral'
import moment from 'moment'
import config from '../config'
import convert from './convert'

const moneyScale = new humanFormat.Scale({
  MILLION:  1000000,
  BILLION:  1000000000,
  TRILLION: 1000000000000,
})
const lightMoneyScale = new humanFormat.Scale({
  M: 1000000,
  B: 1000000000,
  T: 1000000000000,
})
function formatNumber(number, showHuman,lightFormat, decimals=2){
  showHuman = (typeof showHuman  === 'undefined') ? true : showHuman
  if( typeof number === 'undefined' || number === null  ){ return null }
  number = parseFloat(number)
  if( number < 1000000){
    return showHuman ? numeral(number).format('0,0') : numeral(number).format('0,0.00')
  }
  number = showHuman ? humanFormat(number, { scale: ((lightFormat) ? lightMoneyScale: moneyScale), decimals: decimals }) : numeral(number).format('0,0.00')
  return lightFormat ? number.replace(/ /,'') : number
}
function formatMoney(number, showHuman, currency, lightFormat, decimals=2){
  if( typeof number === 'undefined' || number === null  ){ return null }
  return formatCurrencyCodeAsSymbol(currency) + formatNumber(number, showHuman,lightFormat, decimals)
}
function formatCurrencyCodeAsSymbol(currency){
  if (currency === 'USD') { return '$'; }  // US Dollar
  else if (currency === 'GBP') { return '£'; }  // Pound Sterling
  else if (currency === 'EUR') { return '€'; }  // Euro
  else if (currency === 'JPY') { return 'JPY ¥'; }  // Yen
  else if (currency === 'CAD') { return 'C$'; } // Canadian Dollar
  else if (currency === 'HKD') { return 'HK$'; }  // Hong Kong Dollar
  else if (currency === 'CNY') { return 'CNY ¥'; } // Yuan Renminbi
  else if (currency === 'KRW') { return 'KRW ₩'; } // Won
  else if (currency === 'TWD') { return 'NT$'; } // New Taiwan Dollar
  else if (currency === 'AUD') { return 'A$'; }  // Australian Dollar
  else if (currency === 'CNH') { return 'CNH ¥'; }  // Offshore Chinese Yuan
  else if (currency === 'DKK') { return 'DKK '; }  // Danish Krone
  else if (currency === 'SEK') { return 'SEK '; }  // Swedish Krona
  else if (currency === 'NOK') { return 'NOK '; }  // Norwegian Krone
  else if (currency === 'CHF') { return 'CHF '; }  // Swiss Franc
  else if (currency === 'CZK') { return 'Kč'; } //  Czech Koruna
  else { return '$'; }
}
function formatCurrencyCodeAsLabel(code){
  if (code === 'USD') { return 'US Dollar'; }
  else if (code === 'GBP') { return 'Pound Sterling'; }
  else if (code === 'EUR') { return 'Euro'; }
  else if (code === 'JPY') { return 'Yen'; }
  else if (code === 'CAD') { return 'Canadian Dollar'; }
  else if (code === 'HKD') { return 'Hong Kong Dollar'; }
  else if (code === 'CNY') { return 'Yuan Renminbi'; }
  else if (code === 'KRW') { return 'Won'; }
  else if (code === 'TWD') { return 'New Taiwan Dollar'; }
  else if (code === 'AUD') { return 'Australian Dollar'; }
  else if (code === 'CNH') { return 'Offshore Chinese Yuan'; }
  else if (code === 'DKK') { return 'Danish Krone'; }
  else if (code === 'SEK') { return 'Swedish Krona'; }
  else if (code === 'NOK') { return 'Norwegian Krone'; }
  else if (code === 'CHF') { return 'Swiss Franc'; }
  else if (code === 'CZK') { return 'Czech Koruna'; }
  else { return ''; }
}
function formatDate(date){
  return date ? moment( date ).format('D MMM YYYY') : 'ERR-DATE'
}
function formatPerc(number, round=false, decimals=2){
  if( typeof number === 'undefined' || number === null  ){ return null }
  // number = Math.ceil(number * 10000)/100
  if (number > 0 && number < 0.0001) {
    return '<0.01%'
  }
  let x = 10
  if (decimals > 0 && decimals < 4) {
    x = x**decimals
  }
  number = Math.round(number * 100 * x) / x
  number = (number > 10 || round) ? Math.round(number) : number
  return number + '%'
}
function formatConfig(list,value){
  const found = config.formOptions[list].find( ( entry) =>{
    return entry.value === value
  })
  return found ? found.name : null
}
function legalType(v){
  return formatConfig('type', v)
}
function market(v){
  return formatConfig('market', v)
}
// ["No Data","Large Value","Large Blend","Large Growth","Mid Value","Mid Blend",
// "Mid Growth","Small Value","Small Blend","Small Growth"]
function equityStyle(v){
  if( typeof v === 'undefined' || !v ){ return 'No Data' }
  v = parseInt(v,10)
  switch( v ){
    case 1:
      return 'Large Value'
    case 2:
      return 'Large Blend'
    case 3:
      return 'Large Growth'
    case 4:
      return 'Mid Value'
    case 5:
      return 'Mid Blend'
    case 6:
      return 'Mid Growth'
    case 7:
      return 'Small Value'
    case 8:
      return 'Small Blend'
    case 9:
      return 'Small Growth'
  }
  return 'No Data'
}
function sectorLabel(v){
  if( typeof v === 'undefined' || !v ){ return '' }
  v = parseInt(v,10)
  switch( v ){
    case 1:
      return 'Basic materials'
    case 2:
      return 'Consumer cyclical'
    case 3:
      return 'Financial services'
    case 4:
      return 'Real estate'
    case 5:
      return 'Consumer defensive'
    case 6:
      return 'Healthcare'
    case 7:
      return 'Utilities'
    case 8:
      return 'Communication services'
    case 9:
      return 'Energy'
    case 10:
      return 'Industrials'
    case 11:
      return 'Technology'
  }
  return ''
}
function boolean(v){
  v = (v+'').toLowerCase()
  switch( v ){
    case '0.0':
      return 'No'
    case '0':
      return 'No'
    case '1.0':
      return 'Yes'
    case '1.5':
      return 'Yes'
    case '1':
      return 'Yes'
    case 'true':
      return 'Yes'
    case 'false':
      return 'No'
  }
  return null
}
function join(label,value){
  if( typeof value === 'undefined' || !value ){ return null }
  value = parseFloat(value,10)

  if (value === 1.5){
    return label + '-engage'
  } else {
    // console.log(Math.ceil(value))
    return label + (value ? '-'+Math.ceil(value):'')
  }
}
function sanitize(s){
  if (s){
    let result = s.replace(/\s+/g, '-').toLowerCase()
    result = result.replace(/\$/g, '')
    result = result.replace(/%/g, '')
    result = result.replace(/&/g, '')
    result = result.replace(/'/g, '')
    result = result.replace(/\(/g, '')
    result = result.replace(/\)/g, '')
    result = result.replace(/\+/g, '')
    result = result.replace(/,/g, '')
    result = result.replace(/\./g, '')
    result = result.replace(/\//g, '')
    result = result.replace(/\|/g, '')
    result = result.replace(/\xa0/g, '-')
    result = result.replace(/\xae/g, '')
    result = result.replace(/\xd7/g, '')
    result = result.replace(/\u2013/g, '')
    result = result.replace(/\u2014/g, '')
    result = result.replace(/\u2122/g, '')
    return encodeURIComponent(result)
  } else {
    return 'N'
  }
}
function formatLongString(s, max_len=20){
  if( typeof s === 'undefined' || s === null  ){ return null }
  return (s.length > max_len) ? (s.substring(0,max_len-1)+'…') : s
}
function formatShuffle(arr){
  if( typeof arr === 'undefined' || arr === null || arr.length === 0 ){ return null }
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = arr[i]
    arr[i] = arr[j]
    arr[j] = temp
  }
  return arr
}
// thank you stackoverflow
// parseFloat + toFixed is ugly hack
function maybePluralize(count, noun, suffix='s'){
  const _count = parseFloat(count).toFixed(0)
  const _suffix = (_count !== '1' && _count !== '-1') ? suffix : ''
  return `${noun}${_suffix}`
}
function roundsToZero(val) {
  return (val > -0.5 && val < 0.5)
}
function dropStringTrailingZero(str) {
  if (str) {
    return ( str.slice(-2) === '.0' )
           ? str.slice(0, -2)
           : str
  } else {
    return str
  }
}
// thank you stackoverflow
function ordinalSuffix(i){
  const j = i % 10
  const k = i % 100
  if (j === 1 && k !== 11) {
    return 'st'
  }
  if (j === 2 && k !== 12) {
    return 'nd'
  }
  if (j === 3 && k !== 13) {
    return 'rd'
  }
  return 'th'
}
//
// format family name to image path
function isString (value) {
  return typeof value === 'string' || value instanceof String;
}
function imgPath(label){
  if (isString(label)) {
    return label.replace(/[^A-Z0-9]+/ig, '_').toLowerCase()
  }
  return null
}
//
function scoreIntToChar(v){
  if( typeof v === 'undefined' || !v ){ return 'N/A' }
  v = parseFloat(v,10)
  if ( v >= 5 ){
    return 'F'
  }
  else if( v >= 4 ){
    return 'D'
  }
  else if( v >= 3 ){
    return 'C'
  }
  else if( v >= 2.5 ){
    return 'E'
  }
  else if( v >= 2 ){
    return 'B'
  }
  else if( v >= 1.5 ){
    return 'E'
  }
  else if( v >= 1 ){
    return 'A'
  } else {
    return 'N/A'
  }
}
function scoreCharToInt(v){
  if( typeof v === 'undefined' || !v ){ return null }
  if (v === 'A') {
    return 1
  } else if (v === 'B') {
    return 2
  } else if (v === 'C') {
    return 3
  } else if (v === 'D') {
    return 4
  } else if (v === 'F') {
    return 5
  } else if (v === 'E') {
    return 6
  }
}
function gefScore(v, max=100, min=0, decimals=0, asfloat=false){
  // min-max normalization
  if( typeof v === 'undefined' || !v ){ return null }
  v = parseFloat(v,10)
  if (max > 0) {
    const score = parseFloat(((v - min) / (max - min)) * 100.0)
    return (asfloat) ? score : score.toFixed(decimals)
  }
  return null
}
function gefGrade(v){
  if( typeof v === 'undefined' || !v ){ return null }
  v = parseFloat(v,10)
  if( v >= 80 ){
    return 'A'
  }
  else if( v >= 60 ){
    return 'B'
  }
  else if( v >= 40 ){
    return 'C'
  }
  else if( v >= 20 ){
    return 'D'
  }
  else if( v >= 0 ){
    return 'F'
  }
  else {
    return 'ERR'
  }
}
function gefGradeAsInt(v){
  if( typeof v === 'undefined' || !v ){ return -1 }
  let val = null
  switch (v) {
    case 'A':
      val = 1
      break
    case 'E':
      val = 1.5
      break
    case 'B':
      val = 2
      break
    case 'C':
      val = 3
      break
    case 'D':
      val = 4
      break
    case 'F':
      val = 5
      break
    default:
      val = -1
      break
  }
  return val
}
function scoreStyle(score) {
  const _score = convert.float(score)
  if (_score < 10) {
    return 'percentile-10'
  } else if (_score < 20) {
    return 'percentile-20'
  } else if (_score < 30) {
    return 'percentile-30'
  } else if (_score < 40) {
    return 'percentile-40'
  } else if (_score < 50) {
    return 'percentile-50'
  } else if (_score < 60) {
    return 'percentile-60'
  } else if (_score < 70) {
    return 'percentile-70'
  } else if (_score < 80) {
    return 'percentile-80'
  } else if (_score < 90) {
    return 'percentile-90'
  } else if (_score <= 100) {
    return 'percentile-100'
  } else {
    return 'percentile-NaN'
  }
}

function scoreIntToStringLowMedHigh(v){
  if( typeof v === 'undefined' || !v ){ return null }
  v = parseFloat(v,10)
  if (v === 1.0) {
    return 'Low'
  } else if (v === 2.0) {
    return 'Med'
  } else if (v === 3.0) {
    return 'High'
  }
}
function formatFossilFuelGradeTooltip(weight, grade, group, html=true){
  let result = html ? "<div style='max-width:200px;white-space:normal;'>" : ''
  // const _prank = Math.round((prank * 100) * 100) / 100;
  const _weight = Math.round((weight * 100.0) * 100) / 100;
  switch (grade) {
    case 'A':
      result += `Earns a grade of ${grade} for fossil fuel exposure of 0%!`
      break
    case 'B':
      result += `Fossil fuel exposure of ${_weight}% places the fund in the ${grade} grade range of between 0% and 4% exposure.`
      break
    case 'C':
      result += `Fossil fuel exposure of ${_weight}% places the fund in the ${grade} grade range of between 4% and 7% exposure.`
      break
    case 'D':
      result += `Fossil fuel exposure of ${_weight}% places the fund in the ${grade} grade range of between 7% and 11% exposure.`
      break
    case 'F':
      result += `Fossil fuel exposure of ${_weight}% places the fund in the ${grade} grade range of between 11% and 100% exposure.`
      break
    default:
      result = 'ERROR'
      break
  }
  return html ? (result + '</div>') : result
}

function tooltipHtml(text) {
  return `
    <div style='max-width:200px;white-space:normal;'>
      ${text}
    </div>
  `
}

export default {
  number: formatNumber,
  money: formatMoney,
  currencySymbol: formatCurrencyCodeAsSymbol,
  currencyCode: formatCurrencyCodeAsLabel,
  formatDate: formatDate,
  perc: formatPerc,
  formatConfig: formatConfig,
  legalType: legalType,
  market: market,
  equityStyle: equityStyle,
  sectorLabel: sectorLabel,
  boolean: boolean,
  join: join,
  sanitize: sanitize,
  longString: formatLongString,
  shuffle: formatShuffle,
  maybePluralize: maybePluralize,
  roundsToZero: roundsToZero,
  dropStringTrailingZero:dropStringTrailingZero,
  ordinalSuffix: ordinalSuffix,
  // for family images
  isString: isString,
  imgPath: imgPath,
  // for IYV letter grades
  score: scoreIntToChar,
  scoreAsInt: scoreCharToInt,
  // gef only
  gefScore: gefScore,
  gefGrade: gefGrade,
  gefGradeAsInt: gefGradeAsInt,
  scoreStyle: scoreStyle,
  // fff only
  scoreTip: formatFossilFuelGradeTooltip,
  // deprecated
  shortscore: scoreIntToStringLowMedHigh,
  tooltipHtml,
}
